// Konfiguracja tabeli „Sprzedaż rozpoczęta” na karcie klienta (Panel Handlowca)

import { IWiseTableColumn, IWiseTableParameter, IWiseTableAction } from 'components/wise';
import { ILoadDataParam } from 'plugins/api/types';

/**
 * Parametry (opcje nad tabelą) – brak
 */
export const getTraderClientCardSalesTableParameters = (
): IWiseTableParameter[] => {
  return [];
};

/**
 * Kolumny tabeli: numer oferty, data oferty, wartość netto, status
 */
export const getTraderClientCardSalesTableColumns = (
  t: (key: string) => string
): IWiseTableColumn[] => {
  return [
    {
      type: 'text',
      label: t('Numer oferty'),
      field_symbol: 'number',
      align: 'left',
      tooltip: null,
      size: 160
    },
    {
      type: 'date',
      label: t('Data oferty'),
      field_symbol: 'sys_insert_date',
      align: 'center',
      tooltip: null,
      size: 120
    },
    {
      type: 'text',
      label: t('Wartość netto'),
      field_symbol: 'value_net_formatted',
      align: 'right',
      tooltip: null,
      size: 130
    },
    {
      type: 'text',
      label: t('Status'),
      field_symbol: 'status_formatted',
      align: 'center',
      tooltip: null,
      size: 130
    }
  ];
};

/**
 * Akcje tabeli – brak
 */
export const getTraderClientCardSalesTableActions = (
): IWiseTableAction[] => {
  return [];
};

/**
 * Parametry do pobierania danych - realny endpoint SalesCRM ofert klienta.
 * Endpoint: GET /api/ui/sales-crm/clients/{clientId}/offers
 */
export const traderClientCardSalesTableLoadDataParams: ILoadDataParam = {
  get_url: '/sales-crm/clients/:clientId/offers',
  params_list: null
};
